import axios from 'axios'
import { ALTERAR_DETALHAMENTO_FECHAMENTO_CAIXA, ALTERAR_DETALHAMENTO_FECHAMENTO_CAIXA_DIA } from '../../types'
import { URL } from '../../../util/ambienteActions';
import { SLOW_REQUEST_CONFIG } from '../../../util/loadingUtil';

export default function alterarExibicaoDetalhamentoFechamentoCaixa (fechamento, idEmpresa) {
  if (fechamento.detalhamento) {
    return {
      type: fechamento.seFechamentoDia ? ALTERAR_DETALHAMENTO_FECHAMENTO_CAIXA_DIA : ALTERAR_DETALHAMENTO_FECHAMENTO_CAIXA,
      payload: { fechamento }
    };
  }
  const url = `${URL}/fechamento-caixa-usuario/empresa/${idEmpresa}/usuario/${fechamento.idUsuarioEmpresa}/data/${fechamento.dataFechamentoSemFormatacao}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG)
    .then(
      response => dispatch({
        type: fechamento.seFechamentoDia ? ALTERAR_DETALHAMENTO_FECHAMENTO_CAIXA_DIA : ALTERAR_DETALHAMENTO_FECHAMENTO_CAIXA,
        payload: { response, fechamento }
      })
    );
}
